export const config = {
   CYBRID_API : 'https://bank.sandbox.cybrid.app',
   BACKEND_API : 'https://dev-api.thecryptoexchange.ca/',
   PERSONA_ENVIRONMENT : "sandbox"
}
